<template>
    <page-list ref='pageList' request-url="/stat/platform/sale/financereport" :getParams="getQueryParams">
      <template #row="{row}">
        <van-row style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
          <van-col span="20"><span style="font-weight: 500;font-size: 20px">{{row.settlementDate}}</span></van-col>
          <van-col span="4" style="text-align: right" ><span style="font-weight: 500;font-size: 20px;background-color: #07c160;padding: 4px 10px;border-radius: 8px;color: #FFFFFF">{{row.customerCount}}</span></van-col>
          <van-col span="12">订单数: {{row.orderCount}}</van-col>
          <van-col span="12">子订单数: {{row.orderSubCount}}</van-col>
          <van-col span="12">销售总金额: {{row.saleTotalAmount}}</van-col>
          <van-col span="12">优惠总金额: {{row.discountTotalAmount}}</van-col>
          <van-col span="12">实收总金额: {{row.receivedTotalAmount}}</van-col>
          <van-col span="12">应收总金额: {{row.receivableTotalAmount}}</van-col>
          <van-col span="12">采购成本: {{row.purchaseCost}}</van-col>
          <van-col span="12">退/补金额: <span style="font-weight: 500;font-size: 20px" :class="row.differentialAmount >0?'profit':'loss'">{{row.differentialAmount}}</span></van-col>
          <van-col span="12">收益金额: {{row.yieldAmount}}</van-col>
          <van-col span="12">收益率: <span style="font-weight: 500;font-size: 20px" :class="row.yieldRate >0?'profit':'loss'">{{row.yieldRate}}%</span></van-col>
        </van-row>
      </template>
    </page-list>
</template>

<script>
import PageList from '@/components/tools/PageList'
export default {
  name: 'StatSaleList',
  components: { PageList },
  created () {
  },
  data () {
    return {
    }
  },
  computed: {

  },
  methods: {
    getQueryParams (params) {
      const param = Object.assign({}, params)
      param.settlementDate = null
      return { params: param }
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
    }
  }

}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
  .profit {
    color: #07c160;
  }
  .loss {
    color: #ee0a24;
  }
  .warn {
    color: #ed8b08
  }
</style>
